"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Browser = /*#__PURE__*/function () {
  function Browser() {
    _classCallCheck(this, Browser);
  }

  _createClass(Browser, null, [{
    key: "getBrowserProperty",
    value: function getBrowserProperty() {
      try {
        var documentElement = document.documentElement;
        var body = document.getElementsByTagName('body')[0];
        var x = window.innerWidth || documentElement.clientWidth || body.clientWidth;
        var y = window.innerHeight || documentElement.clientHeight || body.clientHeight;
        return {
          screenWidth: x,
          screenHeight: y
        };
      } catch (e) {
        new Error("Exception in method.getBrowserProperty ".concat(e));
      }
    }
    /**
     * Determine the web device.
     * This function returns one of 'Tablet', 'Mobile', or 'Desktop'
     * @returns {String}
     */

  }, {
    key: "getWebDevice",
    value: function getWebDevice() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var isWindowPhone = /windows phone/i.test(userAgent);
      var isAndroidPhone = /android/i.test(userAgent); // iOS detection from: http://stackoverflow.com/a/9039885/177710

      var isApplePhone = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream; // Windows Phone must come first because its UA also contains "Android"

      if (isWindowPhone || isAndroidPhone || isApplePhone) {
        return window.innerWidth > 1023 || window.innerHeight > 1023 ? 'Tablet' : 'Mobile';
      }

      return 'Desktop';
    }
  }]);

  return Browser;
}();

exports["default"] = Browser;